<template>
  <section class="p-1">
    <div>
      <v-form ref="complincmanual" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="d-flex justify-space-between p-0 m-0">
            <div class="ps-2 headingFontsize">Partner User</div>
            <div>
              <bread-crumb :bread-crumbs="['Add Partner']" />
            </div>
          </v-card-title>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <!-- <v-toolbar flat dense>
            <v-toolbar-title class="subtitleFontsize"
              >Personal Information</v-toolbar-title
            >
          </v-toolbar> -->
          <v-card-text class="mt-5">
            <OverlayPageVue :showOverlay="loaderOverlay" />
            <v-row justify="center" class="ms-1 me-1">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required">First Name</label>
                <v-text-field
                  placeholder="First Name"
                  class="rounded height"
                  :rules="first_nameRules"
                  required
                  outlined
                  v-model="basicpartnerDetails.first_name"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize">Middle Name</label>
                <v-text-field
                  placeholder="Middle Name"
                  class="rounded"
                  outlined
                  dense
                  v-model="basicpartnerDetails.middle_name"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required">Last Name</label>
                <v-text-field
                  placeholder="Last Name"
                  class="rounded"
                  required
                  outlined
                  dense
                  :rules="last_nameRules"
                  v-model="basicpartnerDetails.last_name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" class="ms-1 me-1 mt-1" xs="6">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required">Mobile Number</label>
                <v-text-field
                  placeholder="Mobile Number"
                  class="rounded"
                  required
                  outlined
                  dense
                  prefix="+60"
                  type="number"
                  hide-spin-buttons
                  :hint="'+60 xx xxx xxxx'"
                  :rules="contactNumbrules"
                  v-model="basicpartnerDetails.phone_number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Country</label>
                <v-autocomplete
                  v-model="basicpartnerDetails.country_code"
                  class="rounded"
                  :items="CountryList"
                  outlined
                  dense
                  placeholder="Country"
                  :rules="CountryRules"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Nationality</label>
                <v-autocomplete
                  :items="NationalityList"
                  class="rounded"
                  v-model="basicpartnerDetails.nationality_code"
                  outlined
                  dense
                  placeholder="Nationality"
                  :rules="nationalityRules"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="ms-1 me-1 mt-1">
              <!-- <v-col cols="12" md="4">
                  <label class="my-0 labelFontsize">Personal Email</label>
                  <v-text-field
                    placeholder="Personal Email"
                    class="rounded"
                    required
                    outlined
                    dense
                    v-model="basicpartnerDetails.personal_email"
                    :rules="emailRules"
                  >
                  </v-text-field>
                </v-col> -->

              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">
                  Email (User Id)</label
                >
                <v-text-field
                  placeholder="Email"
                  class="rounded"
                  required
                  outlined
                  dense
                  v-model="basicpartnerDetails.email"
                  :rules="emailRules"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <label class="my-0 required labelFontsize">Designaton</label>
                <v-text-field
                  placeholder="Designaton"
                  class="rounded"
                  required
                  outlined
                  dense
                  :rules="designationRules"
                  v-model="basicpartnerDetails.designation"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 required labelFontsize">Department</label>
                <v-text-field
                  placeholder="Department"
                  class="rounded"
                  required
                  outlined
                  dense
                  :rules="departmentRules"
                  v-model="basicpartnerDetails.department"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="ms-1 me-1 mt-1">
              <!-- <v-col cols="12" md="4">
                  <label class="my-0 labelFontsize">Sub Divison</label>
                  <v-text-field
                    placeholder="Sub Division"
                    class="rounded"
                    required
                    outlined
                    dense
                    :rules="subdivisionRules"
                    v-model="basicpartnerDetails.sub_division"
                   
                  >
                  </v-text-field>
                </v-col>
  
                <v-col cols="12" md="4">
                  <label class="my-0 labelFontsize">Joined Date</label>
                  <v-text-field
                    type="date"
                    required
                    class="rounded"
                    outlined
                    dense
                    v-model="basicpartnerDetails.joined_date"
                    :rules="joiningdateRules"
                  >
                  </v-text-field>
                </v-col> -->
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize">Assign Roles</label>
                <v-autocomplete
                  :items="items"
                  dense
                  outlined
                  v-model="basicpartnerDetails.role_code"
                  class="rounded"
                  placeholder="Assign Roles"
                >
                </v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" md="4">
                <label class="my-0 labelFontsize">User Type</label>
                <v-autocomplete
                  dense
                  outlined
                  :rules="user_typeRules"
                  v-model="basicpartnerDetails.assign_roles"
                  class="rounded"
                  placeholder="User Type"
                >
                </v-autocomplete>
              </v-col> -->
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required"
                  >Lock if not login
                  <i style="font-size: 10px">(days,if not logged in.)</i></label
                >
                <v-text-field
                  placeholder="Lock if not login"
                  class="rounded"
                  required
                  outlined
                  dense
                  :rules="lockifnotrules"
                  v-model="basicpartnerDetails.lock_if_not_login"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required"
                  >Date Limited
                  <i style="font-size: 10px"
                    >(Blank or '0' mean Unlimited Date)</i
                  >
                </label>
                <v-text-field
                  v-model="basicpartnerDetails.date_limited"
                  class="rounded"
                  outlined
                  type="date"
                  dense
                  placeholder="Date Limited"
                  :rules="datelimitRules"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center" class="ms-1 me-1 mt-1" xs="6">
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Address</label>
                <v-text-field
                  class="rounded"
                  v-model="basicpartnerDetails.address"
                  outlined
                  dense
                  placeholder="Address"
                  :rules="addressRule"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Partner Name</label>
                <v-autocomplete
                  class="rounded"
                  v-model="basicpartnerDetails.partner_id"
                  outlined
                  dense
                  item-text="txt"
                  item-value="val"
                  :items="partnerList"
                  placeholder="Partner Name"
                  :rules="parner_nameRules"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Branch Name</label>
                <v-text-field
                  v-model="basicpartnerDetails.branch_id"
                  class="rounded"
                  outlined
                  dense
                  placeholder="Branch Name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="start" class="ms-1 me-1 mt-1" xs="6">
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required"
                  >View Past Trans.Limit
                  <i style="font-size: 10px">(days, can see.)</i></label
                >
                <v-text-field
                  class="rounded"
                  v-model="basicpartnerDetails.view_past_txns"
                  outlined
                  dense
                  placeholder="View Past Trans.Limit"
                  :rules="translimitRules"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize">Remarks</label>
                <v-text-field
                  class="rounded"
                  outlined
                  dense
                  placeholder="Remarks"
                  v-model="basicpartnerDetails.remarks"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <div class="row">
              <div
                class="col-md-12"
                style="display: flex; justify-content: end"
              >
                <v-btn depressed 
                  small
                  color="primary"
                  class="mb-10 me-2 text-capitalize"
                  @click="onSubmitFor()"
                >
                  {{ $route.query.login_id ? "Update" : "Add" }}
                </v-btn>

                <v-btn depressed 
                  small
                  color="primary"
                  class="me-4 mb-10 text-capitalize"
                  outlined
                  @click="cancel()"
                >
                <v-icon small class="me-2">mdi-close-circle-outline</v-icon> Cancel
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
    </div>
  </section>
</template>
<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
// import Loading from "vue-loading-overlay";
import { validation } from "@/utils/validationCopy.js";
import alerts from "@/mixins/alerts";
import commonService from "@/services/CommonService/commonService.js";
import userService from "@/services/UserService/userService.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import { checkNumber, mapMobilenumb } from "@/utils/contactNumber/formatNumber";
// import { required, email, numeric } from "vuelidate/lib/validators";
// import { alpha } from "@/utils/validate";

export default {
  mixins: [alerts],
  name: "Add Partner",
  data: () => ({
    ...validation,
    checkNumber,
    loaderOverlay: false,
    mapMobilenumb,
    NationalityList: [],
    CountryList: [],
    partnerList: [],
    // loader: false,
    valid: true,
    basicpartnerDetails: {
      email: "",
      staff_id: "",
      first_name: "",
      last_name: "",
      middle_name: "",
      address: "",
      phone_number: "",
      country_code: "",
      nationality_code: "",
      designation: "",
      department: "",
      role_code: "",
      is_partner_user: true,
      partner_id: "",
      branch_id: "",
      view_past_txns: null,
      date_limited: null,
      remarks: "",
      user_type: "PRT",
      lock_if_not_login: null,
    },

    items: ["Owner", "test", "TestRoles"],
  }),

  components: {
    BreadCrumb,
    // Loading,
    OverlayPageVue,
  },

  mounted() {
    this.getcountryList();
    this.getnational();
    this.getPartner();
    console.log("route.query.login_id  " + this.$route.query.login_id);
    this.editpage();
    // console.log("routerItem deatils " + JSON.stringify(this.basicpartnerDetails ));
  },

  watch: {
    "basicpartnerDetails.partner_id"(val) {
      console.log("val", val);
    },
    "basicpartnerDetails.country_code"(val) {
      console.log(val);
    },
    "$route.query.login_id": {
      immediate: true,
      handler(newVal) {
        console.log(newVal + "value");
        this.editpage();
        // make actions with newVal.page
      },
    },
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    onSubmitFor() {
      if (this.$route.query.login_id) {
        console.log("details");
        this.update();
      } else {
        console.log("else");
        this.postList();
        // console.log('update')
      }
    },
    cancel() {
      if (this.$route.query.login_id) {
        this.$router.push({ name: "List Of Partners" });
        this.$refs.complincmanual.reset();
      } else {
        console.log("else");
        this.$refs.complincmanual.reset();
        // console.log('update')
      }

      // this.$refs.complincmanual.resetErrorBag();
    },
    oncancel() {
      if (this.$route.query.login_id) {
        this.$router.push({ name: "ListUser" });
      } else {
        this.$v.$reset();
        this.basicpartnerDetails = Object.assign({}, {});
        // console.log('update')
      }
    },
    async getnational() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getdropdowns();
        if (response.data.status_code === 200) {
          this.NationalityList = response.data.data.map((i) => {
            return { text: i.nationality, value: i.iso_alpha3 };
          });
          console.log("Nationalty", this.NationalityList);
          this.stoploader();
        } 
        // else if (response.data.status_code === 401) {
        //   this.NationalityList = [];
        //   this.returnNewToken();
        //   this.getNationality();
        //   this.stoploader();
        // }
         else {
          this.NationalityList == [];
          this.stoploader();
        }
      } catch (error) {
        this.NationalityList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getcountryList() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getdropdowns();
        if (response.data.status_code === 200) {
          this.CountryList = response.data.data.map((i) => {
            return { text: i.country_name, value: i.iso_alpha3 };
          });
          console.log("CountryList", this.CountryList);
          this.stoploader();
        }
        //  else if (response.data.status_code === 401) {
        //   this.CountryList = [];
        //   this.returnNewToken();
        //   this.getcountryList();
        //   this.stoploader();
        // } 
        else {
          this.CountryList == [];
          this.stoploader();
        }
      } catch (error) {
        this.CountryList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getPartner() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getPartnerdropdown();
        if (response.data.status_code === 200) {
          this.partnerList = response.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
          console.log("partnerList", this.partnerList);
        }
        if (this.basicpartnerDetails.partner_id) {
          this.basicpartnerDetails.partner_id =
            this.basicpartnerDetails.partner_id.partner_name;
          this.stoploader();
        }
        //  else if (response.data.status_code === 401) {
        //   this.partnerList = [];
        //   this.returnNewToken();
        //   this.getPartner();
        //   this.stoploader();
        // }
         else {
          this.partnerList == [];
          this.stoploader();
        }
      } catch (error) {
        this.partnerList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async postList() {
      const validate = this.$refs.complincmanual.validate();
      const Num_format = this.checkNumber(
        this.basicpartnerDetails.phone_number
      );
      this.basicpartnerDetails.phone_number = Num_format;
      if (validate) {
        this.loaderOverlay = true;
        try {
          const responseData = await userService.PostpartnerUser(
            this.basicpartnerDetails
          );
          if (responseData && responseData.data.status_code == 200) {
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
            this.cancel();
            setTimeout(
              () => this.$router.push({ name: "List Of Partners" }),
              500
            );
          } 
          // else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.postList();
          // } 
          else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async update() {
      const Num_format = this.checkNumber(
        this.basicpartnerDetails.phone_number
      );
      this.basicpartnerDetails.phone_number = Num_format;

      this.loaderOverlay = true;
      try {
        const responseData = await userService.UpdatepartnerUser(
          this.$route.query.login_id,
          this.basicpartnerDetails
        );
        if (responseData && responseData.data.status_code == 200) {
          this.stoploader();
          this.showAlertSuccess(responseData.data.message);
          setTimeout(
            () => this.$router.push({ name: "List Of Partners" }),
            300
          );
        }
        //  else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.update();
        // }
         else {
          this.showAlertError(responseData.data.message);
          this.stoploader();
        }
      } catch (error) {
        console.log(error.response);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async editpage() {
      const routerDataItem = this.$route.query.login_id;
      if (routerDataItem) {
        try {
          const response = await userService.getPartneruserbyId(routerDataItem);
          if (response.data.status_code === 200) {
            this.userList = response.data.data;
            console.log("userList", this.userList);
            this.stoploader();
          } 
          // else if (response.data.status_code === 401) {
          //   this.userList = [];
          //   this.returnNewToken();
          //   this.editpage();
          //   this.stoploader();
          // }
          this.basicpartnerDetails = response.data.data[0];
          const Num_format = this.mapMobilenumb(
            this.basicpartnerDetails.phone_number
          );
          this.basicpartnerDetails.phone_number = Num_format;

          this.basicpartnerDetails.partner_id =
            response.data.data[0].partner_id.partner_id;
        } catch (error) {
          this.userList = [];
          this.stoploader();
          console.error(error);
        }
      } else {
        console.log("basicpartnerDetails");
        this.basicpartnerDetails = {
          email: "",
          staff_id: "",
          first_name: "",
          last_name: "",
          middle_name: "",
          address: "",
          phone_number: "",
          country_code: "",
          nationality_code: "",
          designation: "",
          department: "",
          role_code: "",
          is_partner_user: true,
          partner_id: "",
          branch_id: "",
          view_past_txns: null,
          date_limited: null,
          remarks: "",
          user_type: "PRT",
          lock_if_not_login: null,
        };
      }
    },
  },
};
</script>
<style lang="css">
.required:after {
  content: " *";
  color: red;
}
</style>
